import { Icon, IconProps } from "@chakra-ui/react";

/**
 * Wavy / sine-curve underline used as a decorative emphasis under section
 * headings (e.g. Monthly Rewards Hub). Distinct from `SquiggleIcon`, which
 * renders a triangular flag shape rather than a true wave.
 */
export function WavyUnderlineIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 60 8" fill="none" {...props}>
      <path
        d="M1 4C5 1, 10 7, 15 4S25 1, 30 4S40 7, 45 4S55 1, 59 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
